import type { ResumeDto } from "@reactive-resume/dto";

import { RESUME_KEY, RESUMES_KEY } from "@/client/constants/query-keys";
import { queryClient } from "@/client/libs/query-client";

export const getResumeQueryKey = (id: string) => [...RESUME_KEY, { id }] as const;

/**
 * The usage snapshot (/api/billing/usage) returns a live resume count, so any
 * create / delete / duplicate / import path needs to invalidate this query
 * along with the resume list. Centralised here so call sites don't have to
 * remember.
 */
const USAGE_LIMIT_KEY = ["usage-limit"] as const;

export const syncResumeMutationCache = async (resume: ResumeDto) => {
  queryClient.setQueryData<ResumeDto>(getResumeQueryKey(resume.id), resume);
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: RESUMES_KEY }),
    queryClient.invalidateQueries({ queryKey: USAGE_LIMIT_KEY }),
  ]);
};

export const removeResumeMutationCache = async (resumeId: string) => {
  queryClient.removeQueries({ queryKey: getResumeQueryKey(resumeId) });
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: RESUMES_KEY }),
    queryClient.invalidateQueries({ queryKey: USAGE_LIMIT_KEY }),
  ]);
};
